const FrozenCameraIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="26" height="21" viewBox="0 0 26 21" fill="none">
            <path
                d="M2.0156 0.699194C1.60935 0.378882 1.01951 0.4531 0.699194 0.85935C0.378882 1.2656 0.4531 1.85544 0.85935 2.17576L23.9844 20.3008C24.3906 20.6211 24.9804 20.5469 25.3008 20.1406C25.6211 19.7344 25.5469 19.1445 25.1406 18.8242L21.7656 16.1797L22.3047 16.539C22.6875 16.7929 23.1797 16.8203 23.5898 16.6015C24 16.3828 24.25 15.9609 24.25 15.5V5.49998C24.25 5.03904 23.9961 4.61716 23.5898 4.39841C23.1836 4.17966 22.6914 4.2031 22.3047 4.46091L18.5547 6.96091L18 7.33201V7.99998V13V13.2265L16.75 12.2461V5.49998C16.75 4.12107 15.6289 2.99998 14.25 2.99998H4.94919L2.0156 0.699194ZM16.3984 16.7773L1.76169 5.24607C1.75388 5.3281 1.74998 5.41404 1.74998 5.49998V15.5C1.74998 16.8789 2.87107 18 4.24998 18H14.25C15.164 18 15.9648 17.5078 16.3984 16.7773Z"
                fill="black"
                fillOpacity="0.56"
            />
        </svg>
    );
};

export default FrozenCameraIcon;
